import { notification } from '../../../general/kitMethods';
import { figmaImportTaskUpdated } from '../../../creativeHub/modules/figmaImport/logic';
import { FigmaIcon } from '../../../creativeHub/modules/figmaImport/FigmaIcon';
import { lm } from '../../listenerMiddleware';

export function figmaImportNotifListeners() {
  lm.takeEvery(figmaImportTaskUpdated, (action) => {
    if (action.payload.status !== 'pending' && 'node_id' in action.payload.status) {
      notification.success({
        message: 'Figma import success',
        description: `"${action.payload.originalNode.name}" has been imported`,
        duration: 0,
        icon: <FigmaIcon />,
      });
    }
  });
}
